import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  MainContainer,
  Logo,
  Title,
  Subtitle,
  BlueStrip,
} from '../styles';

const ScreenerSessionError = (props) => {
  const {
    location: {
      state = {},
    },
  } = props;

  return (
    <Container>
      <Logo src="/images/playbook-logo.png" alt="Playbook" />
      <BlueStrip />
      <MainContainer>
        <Title>Error</Title>
        <Subtitle>{state.errors || 'Something went wrong while creating test session'}</Subtitle>
      </MainContainer>
    </Container>
  );
};

ScreenerSessionError.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      errors: PropTypes.string,
    }),
  }).isRequired,
};

export default ScreenerSessionError;
